import { useRef, useState } from "react";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import moment from "moment";

const backend = await new Backend().init();

export default function Filter({
  records = 0,
  search,
  onFilter,
  user_id,
  userType,
  handleBulkDelete,
  selectedTrades,
  downloadExcel,
  downloadUserPDF
}) {
  const searchRef = useRef();

  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [end, setEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [reOpenVisible, setreOpenVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [brokerageVisible, setBrokerageVisible] = useState(false);

  const [tpassword, setTpassword] = useState("");

  // Brokerage states
  const [exchange, setExchange] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [bStart, setBStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [bEnd, setBEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  const handleFilter = () => {
    try {
      onFilter?.({
        start,
        end,
      });
    } catch {
      toast.error("Invalid selection");
    }
  };

  const ReOpen = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      tpassword: tpassword,
      user_id: user_id,
    };

    backend.reopen(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success(r.message);
      } else {
        toast.error(r.message);
      }
    });
  };

  // Brokerage Update
  const updateBrokerage = () => {
    if (!exchange || !brokerage || !bStart || !bEnd || !tpassword) {
      toast.error("All fields required");
      return;
    }

    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user_id,
      exchange: exchange,
      brokerage: brokerage,
      start: bStart,
      end: bEnd,
      tpassword: tpassword,
    };

    backend.update_brokerage(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success("Brokerage Updated Successfully");
        setBrokerageVisible(false);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        background: "var(--background)",
        color: "var(--text)",
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          className="px-3 py-1 rounded-full text-sm font-medium"
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
          }}
        >
          Records: {records || 0}
        </div>

        <input
          ref={searchRef}
          type="text"
          placeholder="Search Symbol"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            search?.(e.target.value);
          }}
          className="w-[180px] px-4 py-1 rounded-full text-sm focus:ring-2 outline-none"
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
          }}
        />
      </div>

      {/* RIGHT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* DATE PICKERS */}
        <input
          type="date"
          value={start}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setStart(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        <input
          type="date"
          value={end}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setEnd(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        {/* FILTER BTN */}
        <button
          onClick={handleFilter}
          className="px-4 py-1.5 bg-[var(--primary)] text-white rounded-full text-sm font-semibold shadow"
        >
          Filter
        </button>

        {/* FILTER BTN */}
        <button
          onClick={downloadExcel}
          className="px-4 py-1.5 bg-[var(--buymeta)] text-white rounded-full text-sm font-semibold shadow"
        >
          EXCEL
        </button>

        {/* FILTER BTN */}
        <button
          onClick={downloadUserPDF}
          className="px-4 py-1.5 bg-[var(--buymeta)] text-white rounded-full text-sm font-semibold shadow"
        >
          PDF
        </button>


        {records > 0 ? (
          <button
            onClick={() => setBrokerageVisible(true)}
            className="px-4 py-1.5 bg-[var(--sell)] text-white rounded-full text-sm font-semibold shadow"
          >
            BROKRAGE
          </button>
        ) : null}

        {records > 0 ? (
          <button
            onClick={() => setreOpenVisible(true)}
            className="px-4 py-1.5 bg-[var(--sell)] text-white rounded-full text-sm font-semibold shadow"
          >
            REOPEN STANDING
          </button>
        ) : null}

        {selectedTrades.length === 0 ? null : (
          <button
            onClick={() => setDeleteVisible(true)}
            className="px-4 py-1.5 bg-[var(--sell)] text-white rounded-full text-sm font-semibold shadow"
          >
            DELETE SELECTED TRADE
          </button>
        )}
      </div>

      {reOpenVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setreOpenVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Sq.Off Standing</h3>
            <p className="customModalWarning">
              This action will ReOpen <b>FORCE SQ.OFF</b> standing.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setreOpenVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={ReOpen}
                disabled={loading}
              >
                {loading ? "ReOpen..." : "Confirm ReOpen"}
              </button>
            </div>
          </div>
        </div>
      )}

      {brokerageVisible && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          onClick={() => setBrokerageVisible(false)}
        >
          <div
            className="w-full max-w-md border-2 border-[var(--hover)] rounded-2xl bg-[var(--background)] shadow-2xl p-6"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Title */}
            <h3 className="text-xl font-bold text-[var(--text)] mb-4">
              Update Brokerage
            </h3>

            {/* Form */}
            <div className="space-y-4">
              {/* Exchange */}
              <div className="bg-[var(--background)]">
                <label className="text-sm font-semibold text-[var(--text)]">
                  Select Exchange
                </label>
                <select
                  value={exchange}
                  onChange={(e) => setExchange(e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-[var(--hover)] rounded-lg bg-[var(--background)] focus:ring-2 focus:ring-[var(--primary)] outline-none"
                >
                  <option value="">Select Exchange</option>
                  <option value="NSE-FUTURE">NSE-FUTURE</option>
                  <option value="MCX-FUTURE">MCX-FUTURE</option>
                  <option value="NSE-OPTIONS">NSE-OPTIONS</option>
                  <option value="NSE-EQUITY">NSE-EQUITY</option>
                </select>
              </div>

              {/* Brokerage */}
              <div>
                <label className="text-sm font-semibold text-[var(--text)]">
                  Brokerage Amount
                </label>
                <input
                  type="number"
                  placeholder="Enter Brokerage"
                  value={brokerage}
                  onChange={(e) => setBrokerage(e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-[var(--hover)] rounded-lg focus:ring-2 bg-[var(--background)] focus:ring-[var(--hover)] outline-none"
                />
              </div>

              {/* Date Range */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm font-semibold text-[var(--text)]">
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={bStart}
                    onChange={(e) => setBStart(e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-[var(--hover)] rounded-lg focus:ring-2 bg-[var(--background)] focus:ring-[var(--hover)] outline-none"
                  />
                </div>

                <div>
                  <label className="text-sm font-semibold text-[var(--text)]">
                    End Date
                  </label>
                  <input
                    type="date"
                    value={bEnd}
                    onChange={(e) => setBEnd(e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-[var(--hover)] rounded-lg focus:ring-2 bg-[var(--background)] focus:ring-[var(--hover)] outline-none"
                  />
                </div>
              </div>

              {/* TPassword */}
              <div>
                <label className="text-sm font-semibold text-[var(--text)]">
                  TPassword
                </label>
                <input
                  type="number"
                  placeholder="Enter TPassword"
                  value={tpassword}
                  onChange={(e) => setTpassword(e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-[var(--hover)] rounded-lg focus:ring-2 bg-[var(--background)] focus:ring-[var(--background)] outline-none"
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setBrokerageVisible(false)}
                className="px-4 py-2 rounded-lg bg-[var(--sell)] border border-[var(--hover)] text-[var(--white)]"
              >
                Cancel
              </button>

              <button
                onClick={updateBrokerage}
                className="px-4 py-2 rounded-lg bg-[var(--primary)] text-white border border-[var(--hover)] font-semibold"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setDeleteVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Clear Data</h3>
            <p className="customModalWarning">
              This action will delete user <b>Selected</b> trade after backup.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setDeleteVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={() => {
                  handleBulkDelete(tpassword);
                  setDeleteVisible(false);
                }}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Confirm Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
